export default __webpack_public_path__ + "static/media/cocktails1.709f4592.jpg";